// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LikeButton_wrapper___McCN","small":"LikeButton_small__k2FsY","icon":"LikeButton_icon__Actjw"};